import { Auth0Provider } from "@auth0/auth0-react";
import type { ReactNode } from "react";

const Auth0ProviderWithHistory = ({ children }: { children: ReactNode }) => {
    const domain = import.meta.env.REACT_APP_AUTH0_DOMAIN;
    const clientId = import.meta.env.REACT_APP_AUTH0_CLIENT_ID;

    return (
        <Auth0Provider
            domain={domain}
            clientId={clientId}
            authorizationParams={{ redirect_uri: `${window.location.origin}/app` }}
        >
            {children}
        </Auth0Provider>
    );
};

export default Auth0ProviderWithHistory;
